import React, { useMemo, useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Routes from 'routes';
import Loader from 'components/loader';
import { useStore } from 'hooks';
import 'react-toastify/dist/ReactToastify.css';

const LOADER_DELAY_MS = 300;

const App = () => {
  const { loading, socket } = useStore();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowLoader(false);
      return undefined;
    }
    const timer = setTimeout(() => setShowLoader(true), LOADER_DELAY_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  useEffect(() => {
    if (socket) {
      socket.on('NOTIFICATION_SUCCESS', message => toast.success(message));
      socket.on('NOTIFICATION_ERROR', message => toast.error(message));
    }

    return () => {
      if (socket) {
        socket.off('NOTIFICATION_SUCCESS');
        socket.off('NOTIFICATION_ERROR');
      }
    };
  }, [socket]);

  return (
    <>
      <Routes />
      {useMemo(() => <ToastContainer />, [])}
      {showLoader && <Loader />}
    </>
  );
};

export default App;
